module.exports = __webpack_public_path__ + "static/media/c-italian.5c259045.jpg";